module.exports = __webpack_public_path__ + "img/application.a02e1c9a.png";